// @flow
type TVoteBlock = {
    name?: string,
};

type TVoteBlockState = {
    data: TVoteBlock,
};
const initialState: TVoteBlockState = {
    data: {},
};

type TSetVoteBlock = {payload: TVoteBlock, type: 'SET_VOTE_BLOCK'};

type TVoteBlockActionList = TSetVoteBlock;

function voteBlockReducer(state: TVoteBlockState = initialState, {type, payload}: TVoteBlockActionList) {
    switch (type) {
        case 'SET_VOTE_BLOCK':
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
}

export {voteBlockReducer};
export type {TVoteBlock, TSetVoteBlock, TVoteBlockState};
